import React from 'react';
import { Box, ListItemButton, ListItemIcon, ListItemText } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { useTheme } from '@mui/material/styles';
import { NavLink } from 'react-router-dom';
import { useRouteMatch } from 'react-router';

import useMediaQuery from '@mui/material/useMediaQuery';
import { useAlert } from 'react-alert';
import { useL10n } from '@uplift/hooks';
import { Tooltip } from '../../../Tooltip';


const useStyles = makeStyles({ name: 'MainLayoutSideBarNavigationItem' })({
  text: {
    '& span': {
      marginTop: '5px',
      color: 'rgba(0, 0, 0, 0.54)',
    },
  },
});


export type NavigationItemProps = {
  icon: React.ReactNode;
  activeIcon?: React.ReactNode;
  disabled?: boolean;
  restricted?: boolean;
  text: string;
  to: string;
  exact?: boolean;
  activeClassName?: string;
  toggleSideBar?: () => void;
  onDisabledClick?: () => void;
};


export const NavigationItem: React.FC<NavigationItemProps> = (props) => {
  const theme = useTheme();
  const l10n = useL10n();
  const isSmallBreakpoint = useMediaQuery(theme.breakpoints.down('md'));
  const { icon, activeIcon, text, to, exact, activeClassName, toggleSideBar } = props;
  const snackbar = useAlert();

  const { classes } = useStyles();

  const CustomLink = React.useMemo(
    () =>
      React.forwardRef<HTMLAnchorElement>((linkProps, ref) => (
        <NavLink
          exact={exact}
          ref={ref}
          to={to}
          activeClassName={activeClassName}
          {...linkProps}
        />
      )),
    [ to ]
  );

  const match = useRouteMatch({
    path: to,
    exact: props.exact,
  });

  const listItem = (
    <ListItemButton disabled={props.disabled || props.restricted} component={CustomLink}>
      <ListItemIcon>{match ? activeIcon || icon : icon}</ListItemIcon>
      <ListItemText primary={text} className={classes.text} />
    </ListItemButton>
  );

  const tooltipText = (
    <div>
      {l10n.accountSettings.billing.accessIsRestrictedTooltip.line1}
      <br />
      {l10n.accountSettings.billing.accessIsRestrictedTooltip.line2}
    </div>
  );

  if (isSmallBreakpoint && props.restricted) {
    return (
      <div onClick={() => {
        toggleSideBar?.();
        snackbar.info(l10n.accountSettings.billing.accessIsRestrictedToast);
      }}
      >
        {listItem}
      </div>
    );
  }
  if (props.restricted) {
    return (
      <Tooltip style={{ width: 'fit-content' }} title={tooltipText}>
        <div style={{ cursor: 'not-allowed' }}>

          {listItem}
        </div>
      </Tooltip>
    );
  }
  return (
    <Box>
      {listItem}
    </Box>
  );
};
